import { AfterViewInit, Component, Input, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Product } from '@vestiaire/api-sdk-angular';
import { PriceDropService } from '@app/shared/services/price-drop/priceDrop.service';
import { select, Store } from '@ngrx/store';
import * as fromUser from '@app/core/user/store/reducers';
import { IAppState } from '@app/store';
import { WishlistService } from '@app/shared/services/wishlist/wishlist.service';
import {
  CreatePriceAlertSuccess,
  AddToWishlistSuccess,
  RemoveToWishlistSuccess
} from '@app/+product/store/actions/product.action';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'vc-product-bookmark-actions',
  templateUrl: './product-bookmark-actions.component.html',
  styleUrls: ['./product-bookmark-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductBookmarkActionsComponent implements AfterViewInit, OnDestroy {
  @Input()
  product: Product;
  @Input()
  isLogged: boolean;
  @Input()
  isSeller: boolean;
  public isPriceDropFollow = false;
  public isProductWished = false;
  // TODO remove this to enable alert button on page product
  public showAlert = false;

  private ngUnsubscribe = new Subject<void>();

  constructor(
    private priceDropService: PriceDropService,
    private wishListService: WishlistService,
    private store$: Store<IAppState>,
    private changeDetector: ChangeDetectorRef
  ) {}

  ngAfterViewInit() {
    this.store$.pipe(takeUntil(this.ngUnsubscribe), select(fromUser.getPriceDropFollowItems)).subscribe(
      res => {
        if (res && Array.isArray(res)) {
          this.isPriceDropFollow = res.indexOf(this.product.id) !== -1;
          this.changeDetector.markForCheck();
        }
      },
      err => {
        console.log('something went wrong');
      }
    );
    this.store$.pipe(takeUntil(this.ngUnsubscribe), select(fromUser.getWishedItems)).subscribe(
      res => {
        if (res && Array.isArray(res)) {
          this.isProductWished = res.indexOf(this.product.id) !== -1;
          this.changeDetector.markForCheck();
        }
      },
      err => {
        console.log('something went wrong');
      }
    );
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  togglePriceDropAlert() {
    if (this.isPriceDropFollow) {
      this.deletePriceDropAlert();
    } else {
      this.createPriceDropAlert();
    }
  }

  createPriceDropAlert() {
    this.priceDropService.priceDropFollow(this.product.id).subscribe(
      res => {
        this.isPriceDropFollow = !!res;
        this.store$.dispatch(new CreatePriceAlertSuccess(this.product));
        this.changeDetector.markForCheck();
      },
      error => {
        console.log(error);
      }
    );
  }

  deletePriceDropAlert() {
    this.priceDropService.priceDropUnFollow(this.product.id).subscribe(
      () => {
        this.isPriceDropFollow = false;
        this.changeDetector.markForCheck();
      },
      () => {}
    );
  }

  toggleWishedItem() {
    if (this.isProductWished) {
      this.deleteProductFromWishList();
    } else {
      this.addProductToWishList();
      this.priceDropService.addPriceDropToLocalForage(this.product.id);
    }
  }

  deleteProductFromWishList() {
    this.wishListService.unwishAnItem(this.product.id).subscribe(
      () => {
        this.isProductWished = false;
        this.store$.dispatch(new RemoveToWishlistSuccess(this.product));
        this.changeDetector.markForCheck();
      },
      () => {}
    );
  }

  addProductToWishList() {
    this.wishListService.wishItem(this.product.id).subscribe(
      res => {
        this.isProductWished = !!res;
        this.store$.dispatch(new AddToWishlistSuccess(this.product));
        this.changeDetector.markForCheck();
      },
      () => {}
    );
  }
}
